import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../../response.js';
import { acceptJson, authHeader } from '../../shared.js';
import { subscriptionSpec } from './specs.js';

function details(apiUrl, accessToken, request) {
    return _details.apply(this, arguments);
}
function _details() {
    _details = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, request) {
        return validateResponse(subscriptionSpec, (yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/subscription/${request.subscriptionId}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return _details.apply(this, arguments);
}

export { details };
//# sourceMappingURL=details.js.map
